import { useFetchBondPreviews } from "@portal/api/previews";
import { FilterableDataTable } from "@portal/components/ui/FilterableDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { FC, useMemo } from "react";
import { getBondTableColumns } from "./columns";

export const BondPreviewsAll: FC = () => {
	const { bondPreviews } = useFetchBondPreviews();
	const isMinimalUIEnabled = useIsMinimalBondUIEnabled();
	const columns = useMemo(() => getBondTableColumns(isMinimalUIEnabled), [isMinimalUIEnabled]);

	return (
		<FilterableDataTable
			name="bonds_v2"
			columnDefs={columns}
			getRowUrl={(row) => `/bonds/${row.id}`}
			data={bondPreviews}
			loadingMessage="Loading bonds..."
			enableExportToCSV
		/>
	);
};
